import React from 'react';
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Box,
  Typography,
} from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import BasicDetails from '../Components/BusinessProfilerComp/BasicDetails';
import OtherBusinessDetails from '../Components/BusinessProfilerComp/OtherBusinessDetails';
import NetworkDetails from '../Components/BusinessProfilerComp/NetworkDetails';
import TopBrandDetails from '../Components/BusinessProfilerComp/TopBrandDetails';
import DistributorDetails from '../Components/BusinessProfilerComp/DistributorDetails';
import WareHouseDetails from '../Components/BusinessProfilerComp/WareHouseDetails';

function BusinessProfiler() {
  const [expanded, setExpanded] = React.useState();

  const handleChange = (panel) => (event, newExpanded) => {
    setExpanded(newExpanded ? panel : false);
  };
  return (
    <Box
      sx={{
        padding: 5,
      }}>
      {/* <Accordion
        expanded={expanded === 'panel1'}
        onChange={handleChange('panel1')}
        sx={{
          marginBottom: 1.5,
        }}>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls='panel1-content'
          id='panel1-header'
          sx={{
            padding: 1,
            paddingLeft: 2,
            paddingRight: 2,
          }}>
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'row',
              alignItems: 'center',
              justifyContent: 'space-between',
            }}>
            <div className='pro-vertical-block' />

            <Typography fontWeight={'600'}>Basic Details</Typography>
          </Box>
        </AccordionSummary>
        <AccordionDetails>
          <BasicDetails />
        </AccordionDetails>
      </Accordion> */}

      <Accordion
        expanded={expanded === 'panel2'}
        onChange={handleChange('panel2')}
        sx={{
          marginBottom: 1.5,
        }}>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls='panel1-content'
          id='panel1-header'
          sx={{
            padding: 1,
            paddingLeft: 2,
            paddingRight: 2,
          }}>
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'row',
              alignItems: 'center',
              justifyContent: 'space-between',
            }}>
            <div className='pro-vertical-block' />

            <Typography fontWeight={'600'}>Other Business Details</Typography>
          </Box>
        </AccordionSummary>
        <AccordionDetails>
          <OtherBusinessDetails />
        </AccordionDetails>
      </Accordion>

      <Accordion
        expanded={expanded === 'panel4'}
        onChange={handleChange('panel4')}
        sx={{
          marginBottom: 1.5,
        }}>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls='panel1-content'
          id='panel1-header'
          sx={{
            padding: 1,
            paddingLeft: 2,
            paddingRight: 2,
          }}>
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'row',
              alignItems: 'center',
              justifyContent: 'space-between',
            }}>
            <div className='pro-vertical-block' />

            <Typography fontWeight={'600'}>Distributor Details</Typography>
          </Box>
        </AccordionSummary>
        <AccordionDetails>
          <DistributorDetails />
        </AccordionDetails>
      </Accordion>

      <Accordion
        expanded={expanded === 'panel5'}
        onChange={handleChange('panel5')}
        sx={{
          marginBottom: 1.5,
        }}>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls='panel1-content'
          id='panel1-header'
          sx={{
            padding: 1,
            paddingLeft: 2,
            paddingRight: 2,
          }}>
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'row',
              alignItems: 'center',
              justifyContent: 'space-between',
            }}>
            <div className='pro-vertical-block' />

            <Typography fontWeight={'600'}>Network Details</Typography>
          </Box>
        </AccordionSummary>
        <AccordionDetails>
          <NetworkDetails />
        </AccordionDetails>
      </Accordion>

      <Accordion
        expanded={expanded === 'panel6'}
        onChange={handleChange('panel6')}
        sx={{
          marginBottom: 1.5,
        }}>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls='panel1-content'
          id='panel1-header'
          sx={{
            padding: 1,
            paddingLeft: 2,
            paddingRight: 2,
          }}>
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'row',
              alignItems: 'center',
              justifyContent: 'space-between',
            }}>
            <div className='pro-vertical-block' />

            <Typography fontWeight={'600'}>Warehouse Details</Typography>
          </Box>
        </AccordionSummary>
        <AccordionDetails>
          <WareHouseDetails />
        </AccordionDetails>
      </Accordion>
    </Box>
  );
}

export default BusinessProfiler;
